module.exports = __webpack_public_path__ + "img/gd2.42ad8e97.jpg";